


























































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import HeadBack from '@/views/competition/components/HeadBack.vue'
import { getContestantRoundDetailList, enableOrDisablePlayer,deleteContestantRoundDetail,updateRanking } from '@/api/player'
import { getTitleList } from '@/api/competition'
import { UserModule } from '@/store/modules/user'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import Empty from '@/components/Empty/index.vue'
import { encrypt, decrypt } from '@/utils/crypto'
import { exportInforTwo } from '@/api/index'

@Component({
  name: 'titleManage',
  components: {
    HeadLable,
    InputAutoComplete,
    Empty,
  },
})
export default class extends Vue {
  private input: any = ''
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 50
  private tableData = []
  private id = ''
  private status = ''
  private isSearch: boolean = false
  private options =  []
  private titleId = ''
  private titleId1 = ''
  private title = ''
  private type = ''
  private roundTitle = ''
  private loading1 = 0
  private largeImageUrl = '' // 放大图片的URL
  private imageDialogVisible = false // 控制模态框的显示

    // 判断是否有权限
    private hasPermission(): boolean {
    const roles = UserModule.username || [];
    if (roles.includes('admin') || roles.includes('zhangsan')) return true;
    return false;
  }

  created() {
    if (this.$route.query.titleId) {
      this.titleId1 = this.$route.query.titleId
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title
    }
    if (this.$route.query.roundTitle) {
      this.roundTitle = this.$route.query.roundTitle
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    this.name()
    this.init()
  }

  cancel() {
    this.$router.push({ path: '/competition/scoreRoundManage', query: { titleId: this.titleId1, title: this.title } })
  }

  private jumpTo(st: string, roundTitle: string) {
      this.$router.push({ path: '/competition/scoreContestantRoundDetailManage', query: { contestantId: st, id: this.id, titleId: this.titleId1, title: this.title,roundTitle: this.roundTitle,type: this.$route.query.type } })
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  initProp(val) {
    this.input = val
    this.initFun()
  }

  initFun() {
    this.page = 1
    this.init()
  }

  get userName() {
    return UserModule.username
  }

  private async checkContestant() {
    this.loading1 = 1
    await this.init(true,true)
    this.loading1 = 0
  }

  private async init(isSearch?: boolean,check) {
    this.isSearch = isSearch
    if (this.isSearch == true) {
      this.page = 1
    }
      // if (this.options.length === 0 && this.isSearch !== true){
        // const pageParams = {
        //   page: this.page,
        //   pageSize: this.pageSize,
        //   type: 0,
        // }
        // await getTitleList(pageParams)
        //   .then((res: any) => {
        //     if (String(res.data.code) === '1') {
        //       this.options = res.data && res.data.data && res.data.data.records
        //       if (this.titleId === '') {
        //         this.titleId = res.data.data.records[0].id
        //       }
        //       // this.counts = res.data.data.total
        //     }
        //     // if (!res.data.data.records.length && type === 'search') {
        //     //   this.$message.error('未搜索到相关员工，请核对员工姓名是否正确')
        //     // }
        //   })
        //   .catch((err) => {
        //     this.$message.error('请求出错了：' + err.message)
        //   })
        // }

    const params = {
      page: this.page,
      pageSize: this.pageSize,
      name: this.input ? this.input : undefined,
      titleId: this.titleId,
      round: this.$route.query.id,
      type: this.$route.query.type
    }
    if (check == true) {
      params.checkType = this.type == 0 ? 1 : this.type == 1 ? 2 : 3
    }
    await getContestantRoundDetailList(params)
      .then((res: any) => {
        if (String(res.data.code) === '1') {
          this.tableData = res.data && res.data.data && res.data.data.records
          this.counts = res.data.data.total
        }
        // if (!res.data.data.records.length && type === 'search') {
        //   this.$message.error('未搜索到相关员工，请核对员工姓名是否正确')
        // }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  private async updatePlayerRanking() {
    const params = {
      titleId: this.titleId,
    }
    this.loading1 = 1
    await updateRanking(params)
    .then((res: any) => {
      this.loading1 = 0
      if (String(res.data.code) === '1') {
        this.$message.success('手动规整排名完成')
      }
      this.init()
    })
    .catch((err) => {
      this.$message.error('请求出错了：' + err.message)
    })
  }

    /** 导出按钮操作 */
    handleExport() {
      const param = {
            beginTime:
            this.valueTime && this.valueTime.length > 0
              ? this.valueTime[0]
              : undefined,
            endTime:
              this.valueTime && this.valueTime.length > 0
                ? this.valueTime[1]
                : undefined,
            titleId: this.titleId || undefined,
            smallProgramNumber: this.smallProgramNumber || undefined,
          }
          console.log(param, 'param')
      this.$confirm('是否确认下载赛事轮模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async function () {
          const { data } = await exportInforTwo(param)
          let url = window.URL.createObjectURL(data)
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          let fileName = ''
          console.log(param.beginTime)
          if (param.beginTime) {
            const startDate = new Date(param.beginTime);
            const endDate = new Date(param.endTime);
            fileName = startDate.getFullYear() + '.' + String(startDate.getMonth() + 1).padStart(2, '0') + '.' + String(startDate.getDate()).padStart(2, '0') + '-' + endDate.getFullYear() + '.' + String(endDate.getMonth() + 1).padStart(2, '0') + '.' + String(endDate.getDate()).padStart(2, '0') + '.xlsx'

          } else {
            const date = new Date()
            fileName = date.getFullYear() + '.' + String(date.getMonth() + 1).padStart(2, '0') + '.' + String(date.getDate()).padStart(2, '0') + '.xlsx'
          }
          fileName = '赛事轮模板.xlsx'

          a.download = fileName
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .then((response) => {})
    }

  // 显示放大图片
  private showImage(url: string) {
    this.largeImageUrl = url
    this.imageDialogVisible = true
  }

  // 监听 titleId 的变化
  private handleTitleChange() {
    this.init();
  }

  // 添加
  private addEmployeeHandle(st: string, username: string) {
    if (st === 'add') {
      this.$router.push({ path: '/scoreRoundManage/add', query: { titleId: this.titleId1, title: this.title,round: this.id,roundTitle: this.roundTitle,type: 0 } })
    } else {
      if (username === 'admin') {
        return
      }
      this.$router.push({ path: '/scoreRoundManage/add', query: { id: st, titleId: this.titleId1, title: this.title,round: this.id,roundTitle: this.roundTitle,type: 0 } })
    }
  }

  //状态修改
  private statusHandle(row: any) {
    if (row.username === 'admin') {
      return
    }
    this.id = row.id
    this.status = row.status
    this.$confirm('确认调整该选手的状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      enableOrDisablePlayer({ id: this.id, status: !this.status ? 1 : 0})
        .then((res) => {
          if (String(res.status) === '200') {
            this.$message.success('选手状态更改成功！')
            this.init()
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  // 删除
  private deleteHandle(type: string, id: any) {
    if (type === '批量' && id === null) {
      if (this.checkList.length === 0) {
        return this.$message.error('请选择删除对象')
      }
    }
    const params = {
      ids:type === '批量' ? this.checkList.join(',') : id
    }
    this.$confirm('确认删除该参赛选手, 是否继续?', '确定删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteContestantRoundDetail(params)
        .then(res => {
          if (res && res.data && res.data.code === 1) {
            this.$message.success('删除成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  // 全部操作
  private handleSelectionChange(val: any) {
    let checkArr: any[] = []
    val.forEach((n: any) => {
      checkArr.push(n.id)
    })
    this.checkList = checkArr
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init()
  }
}
